import React, { HTMLInputTypeAttribute } from 'react';
import { Action, ActionContainer, ErrorType, Label, SecLabel, StyledImg, StyledInput } from './style';

type BaseInputProps = {
  type?: HTMLInputTypeAttribute;
  name: string;
  value?: string | number;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  autoComplete?: string;
  defaultChecked?: boolean;
  defaultValue?: string;
  error?: string | undefined | number;
  disabled?: boolean;
  required?: boolean;
  backgroundColor?: string;
  action?: React.ReactNode;
  label?: string;
  secLabel?: string;
  extraStyles?: Record<string, string | {}>;
  onKeyUp?: any;
  tabIndex?: number;
  min?: number;
  maxLength?: number;
  width?: string;
  icon?: any;
  pattern?: RegExp;
  labelStyle?: Record<string, string>;
  inputRef?: React.RefObject<HTMLInputElement>;
};

export const InputField: React.FC<BaseInputProps> = ({
  type = 'text',
  name,
  placeholder,
  value,
  onChange,
  onKeyDown,
  autoComplete,
  error,
  icon,
  disabled,
  defaultChecked,
  defaultValue,
  min = 0,
  action,
  label,
  extraStyles,
  labelStyle,
  secLabel,
  onKeyUp,
  tabIndex,
  maxLength,
  required,
  width,
  inputRef
}) => {

  const passwordFocus = () => {
    if (name !== 'password' && inputRef) inputRef.current?.focus() ;
  };

  return (
    <div style={{ width: width ?? '100%' }}>
      {label && <Label style={labelStyle}>{label}</Label>}
      {secLabel && <SecLabel>{secLabel}</SecLabel>}
      <ActionContainer>
        {icon && <StyledImg src={icon} />}
        <StyledInput
          ref={inputRef}
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          min={min}
          defaultValue={defaultValue}
          defaultChecked={defaultChecked}
          maxLength={maxLength}
          icon={icon}
          onChange={onChange}
          onKeyDown={onKeyDown}
          autoComplete={autoComplete}
          disabled={disabled}
          style={extraStyles}
          tabIndex={tabIndex}
          onKeyUp={onKeyUp}
          onWheel={(e: any) => e.target.blur()}
          required={required}
        />
        {action && <Action onClick={passwordFocus}>{action}</Action>}
      </ActionContainer>
      {error && typeof error === 'string' && <ErrorType>{error}</ErrorType>}
    </div>
  );
};
